export function encodeUTF8Base64 (str) {
    if (typeof TextEncoder === 'function') {
        const bytes = new TextEncoder().encode(str);
        let binary = '';
        const chunkSize = 32768;

        for (let i = 0; i < bytes.length; i += chunkSize) {
            const chunk = bytes.subarray(i, i + chunkSize);
            binary += String.fromCharCode.apply(null, chunk);
        }

        return btoa(binary);
    }

    return btoa(unescape(encodeURIComponent(str)));
}
